import axios from '@/services'

const services = {
  fetchTransactions: async () => await axios.get('/api/quick-search/service-transactions'),
  fetchNameDetails: async () => await axios.get('/api/quick-search/service-name-details'),
  fetchConfig: async (id) =>
    await axios.get('/api/quick-search/service-transactions-config', {
      params: { serviceTransactionId: id }
    })
  // fetchTransactions: async () => await Promise.resolve(quick_search__transactions),
  // fetchNameDetails: async () => await Promise.resolve(quick_search__names)
}

export default services
